import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";
import { COLORS, LIGHT_THEME_COLORS } from "./colors";
import { FLEX } from "./flex";
import * as mediaQuery from "components/MediaQuery";
import LoaderImage from "assets/images/dwloader.png";
import X from "assets/icons/x_map.svg";
import { baseFontFamily, calcRem } from "./theme";
// const defaultRadius = "4px";
// const defaultPadding = "10px";

export const GlobalStyle = createGlobalStyle`
    ${reset};
    /* HTML5 display-role reset for older browsers */
    /* font-size: 14px; */
    * {
        margin: 0;
        padding: 0;
        line-height: none;
    }
    html {

        font-size: 15px;
        ${mediaQuery.is4K} {
            font-size: 18px;
        }
        ${mediaQuery.isMobile} {
            font-size: 13px;
            height: -webkit-fill-available;
        }
    }

    body {
        box-sizing: border-box;
        background-color: ${(props) => props.theme.COLORS.BACKGROUND};

        font-family: ${baseFontFamily};

        ${mediaQuery.isMobile} {
            min-height: -webkit-fill-available;
        }
        [class*="ant-"] {
            font-family: ${baseFontFamily};
        }
    }
    @supports (-webkit-touch-callout: none) {
     height: -webkit-fill-available;
    }

    article, aside, details, figcaption, figure,
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    ol, ul, li {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    /*
    */

    button {
        background: none;
        border: 0;
        cursor: pointer;
        min-width: max-content;

        &:focus {
            outline: none;
        }
    }

  
    a {
        text-decoration: none;
        color: #000;

        &:active {
            color: none;
        }
    }

    strong {
        font-weight: 500;
    }


    img {
        border: none;
        /* object-fit: cover; */
    }
    
    textarea:focus, input:focus {
      outline: none;
    }
    input, input[type="search"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    label {
        ${FLEX.FlexStartCenter};
        gap: 8px;
    }

    /* IE */
    select::-ms-expand { 
        display: none;
    }
    .select {
    -o-appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    }

    // input search x 버튼 초기화
    /* IE의 경우 */
    input::-ms-clear,input::-ms-reveal{
        opacity: 0;
        position: absolute;
        right: 0;}
    /* 크롬의 경우 */
    input::-webkit-search-decoration,
    input::-webkit-search-cancel-button,
    input::-webkit-search-results-button,
    input::-webkit-search-results-decoration{
        opacity: 0;
        position: absolute;
        right: 0;
    }

    input[type='checkbox'],
    input[type='checkbox']:checked,
    input[type='radio'],
    input[type='radio']:checked
     {
        appearance: none;
    }


    input[type='search'] > .search-clear-button {
        position: absolute;  // 위치는 clear button이 생기는곳에 놔주시면 됩니다. 
        top: 0; 
        right: 0; 
        width: 30px; 
        height: inherit; 
        background: ${X} center center no-repeat; 
        background-size: 50%; 
        border: none; 
        outline: none; 
        cursor: pointer;  //해당 버튼이 아닌 뒤의 clear 버튼이 클릭되게하기위해 해당 엘리먼트의  
        pointer-events: none; //클릭을 막아줍니다 
    }


    input[type='checkbox'] {
        background-color: ${COLORS.WHITE};
        width: 16px;
        height: 16px;
        vertical-align: middle;
        border: 1px solid #ACACAC;
        margin-top: -3px;
        border-radius: 2px;
    }
    input[type='checkbox']:not(:disabled),
    input[type='radio']:not(:disabled) {
        cursor: pointer;
    }
    input[type='checkbox']:checked,
    .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner::after  {
        border-radius: 2px;
        background-color: ${({ theme }) => theme.COLORS.SELECTED};
        border: none;
        background: ${({ theme }) =>
          theme.COLORS.SELECTED} no-repeat center center;
        background: ${({ theme }) =>
          theme.COLORS.SELECTED} no-repeat center center;
        background-image: ${({ theme }) =>
          theme.value === "light"
            ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15.607' height='11.639'%3E%3Cpath data-name='Icon awesome-check' d='M5.3 11.41.229 6.338a.78.78 0 0 1 0-1.1l1.1-1.1a.78.78 0 0 1 1.1 0l3.417 3.417L13.165.236a.78.78 0 0 1 1.1 0l1.1 1.1a.78.78 0 0 1 0 1.1L6.4 11.41a.78.78 0 0 1-1.1 0Z' fill='%23fff'/%3E%3C/svg%3E")`
            : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15.607' height='11.639'%3E%3Cpath data-name='Icon awesome-check' d='M5.3 11.41.229 6.338a.78.78 0 0 1 0-1.1l1.1-1.1a.78.78 0 0 1 1.1 0l3.417 3.417L13.165.236a.78.78 0 0 1 1.1 0l1.1 1.1a.78.78 0 0 1 0 1.1L6.4 11.41a.78.78 0 0 1-1.1 0Z' fill='%23000'/%3E%3C/svg%3E")`};
        background-size: 9px 6px; /* 가로 12px, 세로 12px */
    }
    .ant-checkbox .ant-checkbox-inner {
        width: 16px;
        height: 16px;
        border-radius: 2px;
    }
    .ant-checkbox input+.ant-checkbox-inner {background:#fff;border-color:#acacac;}
    .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner:after {
        width: 100%;
        height: 100%;
        transform: rotate(0);
        top: 0;
        left: 0;
        margin: 0;
    }
    .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner::after {
        
        border-color: ${({ theme }) =>
          theme.value === "light" ? COLORS.WHITE : COLORS.BLACK};
    }
    .ant-checkbox.ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
        cursor: pointer;
        background-color: ${({ theme }) => theme.COLORS.SELECTED};
        border-color: ${({ theme }) => theme.COLORS.SELECTED};
    }
    input[type='checkbox']:disabled, .ant-checkbox.ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
        background-color: ${COLORS.BUTTONS1};
        border: none;
        border: 1px solid ${COLORS.BORDER};       
    }
    input[type='checkbox']:indeterminate,
    .ant-checkbox-indeterminate,
    .ant-checkbox-indeterminate input + .ant-checkbox-inner {
        background-color: ${({ theme }) => theme.COLORS.SELECTED};
        border: none;
        background: ${({ theme }) =>
          theme.COLORS.SELECTED} no-repeat center center;
        position: relative;
        // background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='4' viewBox='0 0 12 4'%3E%3Cline id='선_289' data-name='선 289' x2='12' transform='translate(0 2)' fill='none' stroke='%23fff' stroke-width='4'/%3E%3C/svg%3E%0A"); 
    }
    .ant-checkbox-indeterminate input + .ant-checkbox-inner:after {
        background-color: ${({ theme }) =>
          theme.value === "light" ? COLORS.WHITE : COLORS.BLACK};
        height: 2px;
        width: 10px;
    }
    /* input[type='checkbox']:indeterminate::before {
        content: "";
        display: block;
        color: white;
        width: 15px;
        height: 15px;
    } */
    input[type='checkbox']:indeterminate::after {
        content: "";
        display: block;
        width: 10px;
        /* height: 10px; */
        border: solid white;
        border-width: 2px 0 0 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    input[type='radio'] {
        width: 20px;
        height: 20px;
        border: 2px solid ${({ theme }) => theme.COLORS.SELECTED};
        background: ${COLORS.WHITE};
        outline: none;
        border-radius: 50%;
    }
    input[type='radio']:checked {
        background:${({ theme }) => theme.COLORS.SELECTED};
        box-shadow: inset 0 0 0 2px ${COLORS.WHITE};
        border-color:${({ theme }) => theme.COLORS.SELECTED};
    }
    input[type='radio']:disabled {
        background-color: ${({ theme }) => theme.COLORS.DISABLED};
        border-color: ${({ theme }) => theme.COLORS.DISABLED_BORDER};
        border-width: 2px;
    }
    input[type='radio']:disabled:checked {
        background: ${COLORS.BUTTONS1};
        box-shadow: inset 0 0 0 2px ${COLORS.WHITE};
        border-color: ${COLORS.BUTTONS1};
    }

 
.react-grid-item {
    z-index: 1 !important;
}
.react-grid-item.react-grid-item-placeholder {
    z-index: 0 !important;
}
.react-grid-item.react-draggable {
    z-index: 2 !important;
}
.react-grid-item.react-draggable-dragging {
    z-index: 1000 !important;
}
    
.ant-input-number {
    background-color: ${COLORS.WHITE} !important;
    border-radius: 2px;
    border: 1px solid #cacaca;
    box-shadow: none;
    &.ant-input-number-outlined:focus-within {
        box-shadow: none !important;
        border-color: #cacaca;
    }

    .ant-input-number-input {
        background-color: ${COLORS.WHITE} !important;
        padding: 8px 6px;
    }
}
.ant-popover .ant-popover-inner {
    padding: 0 !important;
    background-color: transparent;
  }
.ant-input-number-input-wrap {
    > input {
        padding-right: 28px !important;
        background-color: ${COLORS.WHITE} !important;
    }
}
    body::-webkit-scrollbar {
        width: 5px;  /* 세로축 스크롤바 폭 너비 */
        height: 5px;  /* 가로축 스크롤바 폭 너비 */

    }
    body::-webkit-scrollbar-thumb {
        background: ${({ theme }) =>
          theme.value === "light"
            ? COLORS.LIGHTGRAY
            : "#545E77"}; //스크롤바의 색상
        
        border-radius: 7px;
    }

    body::-webkit-scrollbar-track {
        background: ${({ theme }) =>
          theme.value === "light"
            ? LIGHT_THEME_COLORS.LIGHTGRAY
            : "#273457"}; //스크롤바의 색상

    }

    ::-webkit-scrollbar {
        width: 5px; // 스크롤바의 너비
        height: 8px;  /* 가로축 스크롤바 폭 너비 */
    }
    ::-webkit-scrollbar-thumb {
        background: ${({ theme }) =>
          theme.value === "light"
            ? COLORS.LIGHTGRAY
            : "#545E77"}; //스크롤바의 색상
        border-radius: 7px;
    }
    ::-webkit-scrollbar-track {
        background: ${({ theme }) =>
          theme.value === "light"
            ? LIGHT_THEME_COLORS.LIGHTGRAY
            : "#273457"}; //스크롤바의 색상
    }

    .ant-picker-footer {
        padding: 0 10px;
        .ant-picker-now-btn {
            display: none;
        }
        .ant-picker-ok button {
            box-shadow: none;
            padding: 12px 16px;
            font-size: ${calcRem(14)};
            font-weight: 500;
            border-radius: 2px;
            &:not(:disabled) {
                background-color: ${({ theme }) => theme.COLORS.BUTTONS2};
            }
        }
    }


    .progress-indicator {
        min-height: 12px;
        min-width: 12px;
    }
    
    .progress-indicator:before {
        animation: progressSpin .8s linear infinite;
        background-image: url(${LoaderImage});
        background-size: contain;
        content: "";
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%
    }
    
    .progress-indicator.progress-indicator--responsive {
        height: 48px;
        width: 48px
    }
    
    @media(min-width: 480px) {
        .progress-indicator.progress-indicator--responsive {
            height:72px;
            width: 72px
        }
    }
    
    .progress-indicator.progress-indicator--size-12 {
        height: 12px;
        width: 12px
    }
    
    .progress-indicator.progress-indicator--size-24 {
        height: 24px;
        width: 24px
    }
    
    .progress-indicator.progress-indicator--size-36 {
        height: 36px;
        width: 36px
    }
    
    .progress-indicator.progress-indicator--size-48 {
        height: 48px;
        width: 48px
    }
    
    .progress-indicator.progress-indicator--size-72 {
        height: 72px;
        width: 72px
    }
    
    .progress-indicator.progress-indicator--size-100 {
        height: 100px;
        width: 100px
    }
    
    .progress-indicator.progress-indicator--size-150 {
        height: 150px;
        width: 150px
    }
    
    .progress-indicator.progress-indicator--size-200 {
        height: 200px;
        width: 200px
    }
    
    @keyframes progressSpin {
        to {
            transform: rotate(1turn)
        }
    }
`;
